"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Osn;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Osn(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Brands"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "osn",
    d: "M50,10A39.948,39.948,0,0,1,83.668,71.531c.5-3.078-.051-7-2.512-12.336a68.8,68.8,0,0,0-7.508-12.133C67.68,39.207,60.816,32.1,54.7,24.367c-2.7-3.41-8.492-10.738-6.2-14.3C49,10.047,49.5,10,50,10Zm9.074,78.961c.914-.211,1.813-.465,2.7-.738,6.356-5.02-.992-14.8-12.668-29.512C35.02,40.957,24.828,25.316,28.41,16.371q-1.324.851-2.566,1.8C20.48,28.64,30.457,42.308,45.6,60.828,55.484,72.914,64.031,84.2,59.074,88.961Zm-4.848-49.1C61.449,45.582,67.5,50.531,72.16,54.93A180.547,180.547,0,0,0,60.051,38.918C50.441,27.356,41.344,15.672,44.406,10.43a39.527,39.527,0,0,0-10.66,3.043,9.265,9.265,0,0,0-.875,1.519C31.129,21.539,42.047,30.2,54.226,39.859ZM78.367,78.176C81.453,70.09,71.012,61.308,50.684,44.7A154.652,154.652,0,0,1,37.6,32.949C40.4,37.3,44,41.961,47.766,46.828c15.648,20.266,25.34,32.594,20.042,38.984A40.161,40.161,0,0,0,78.367,78.176Zm-57.8-55.262A40,40,0,0,0,50,90q1.948,0,3.851-.183l.442-.051c5.465-3.68-3.008-13.547-13.067-25.274C31.148,52.734,16.4,35.941,20.859,22.621Z"
  })));
}